const STORAGE_KEY = 'speedy.impersonationSession';

export type ImpersonationSession = {
  returnToken: string;
  adminUid: string;
  targetUid: string;
  /** Display label, e.g. "Jane Doe · jane@example.com" */
  targetLabel: string;
};

export function getImpersonationSession(): ImpersonationSession | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ImpersonationSession>;
    if (
      typeof parsed.returnToken !== 'string' ||
      typeof parsed.adminUid !== 'string' ||
      typeof parsed.targetUid !== 'string' ||
      typeof parsed.targetLabel !== 'string'
    ) {
      return null;
    }
    return {
      returnToken: parsed.returnToken,
      adminUid: parsed.adminUid,
      targetUid: parsed.targetUid,
      targetLabel: parsed.targetLabel,
    };
  } catch {
    return null;
  }
}

export function setImpersonationSession(session: ImpersonationSession): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearImpersonationSession(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isImpersonating(): boolean {
  return getImpersonationSession() != null;
}
